import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LocationsAccordion from './locations-accordion';
import ReimbursementSummaryLeadAccount from '@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-lead-account';
import ReimbursementSummaryMainPanel from './reimbursement-summary-main-panel';
import SelectedPostingDate from '../../state/selected-posting-date';

const ReimbursementSummaryMain = props =>
    <main className='reimbursement-summary-main'>
        <h2 className='header-title'>
            <FormattedMessage
                id='REIMBURSEMENT_SUMMARY'
            />
        </h2>
        {props.selectedLeadAccount ?
            <ReimbursementSummaryMainPanel
                claimCount={props.selectedLeadAccount.approvedClaimCount}
                queryId={props.selectedLeadAccount.id}
                queryString={`leadAccount=${props.selectedLeadAccount.leadAccount.account}&postingDateFrom=${props.selectedPostingDate.postingDateFrom}&postingDateTo=${props.selectedPostingDate.postingDateTo}&leadAccountDisplayName=${encodeURIComponent(props.selectedLeadAccount.leadAccount.name)}`}
                recoveryPercentage={props.selectedLeadAccount.recoveryPercentage}
                recoveryPercentageForIndicator={Math.min(...props.selectedLeadAccount.citySummary.map(city => Math.min(...city.accountSummary.map(account => account.recoveryPercentage))))}
                title={props.selectedLeadAccount.leadAccount.name}
                totalUnpaid={props.selectedLeadAccount.totalUnpaid}
            >
                {props.selectedLeadAccount.citySummary.map((city, cityIndex) =>
                    <ReimbursementSummaryMainPanel
                        claimCount={city.approvedClaimCount}
                        key={cityIndex}
                        queryId={city.id}
                        queryString={`leadAccount=${props.selectedLeadAccount.leadAccount.account}&city=${city.city}&postingDateFrom=${props.selectedPostingDate.postingDateFrom}&postingDateTo=${props.selectedPostingDate.postingDateTo}&leadAccountDisplayName=${encodeURIComponent(props.selectedLeadAccount.leadAccount.name)}`}
                        recoveryPercentage={city.recoveryPercentage}
                        recoveryPercentageForIndicator={Math.min(...city.accountSummary.map(account => account.recoveryPercentage))}
                        title={city.city}
                        totalUnpaid={city.totalUnpaid}
                    >
                        <LocationsAccordion
                            locations={city.accountSummary}
                            selectedLeadAccount={props.selectedLeadAccount}
                            selectedPostingDate={props.selectedPostingDate}
                        />
                    </ReimbursementSummaryMainPanel>
                )}
            </ReimbursementSummaryMainPanel> :
            <section className='error-panel'>
                <FormattedMessage id='PLEASE_SELECT_A_LEAD_ACCOUNT'/>
            </section>
        }
    </main>;

ReimbursementSummaryMain.displayName = 'ReimbursementSummaryMain';
ReimbursementSummaryMain.propTypes = {
    selectedLeadAccount: PropTypes.instanceOf(ReimbursementSummaryLeadAccount),
    selectedPostingDate: PropTypes.instanceOf(SelectedPostingDate)
};

export default ReimbursementSummaryMain;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/reimbursement-summary-main.js